import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PreparedEntry } from "../Utils/Entry";

const initialEntriesState = {
    entries: null as PreparedEntry[]|null,
    awardId: null as string|null,
    isLoading: false,
    filters: {
        searchQuery: "",
    },
}
const entriesSlice = createSlice({
    name: 'EntriesList',
    initialState : initialEntriesState,
    reducers: {
        setEntries(state, action: PayloadAction<{ entries: PreparedEntry[], awardId: string }>) {
            console.log("entriesslice setentries action", action);
            state.entries = action.payload.entries
            state.awardId = ""+action.payload.awardId
        },
        setSearchQuery(state, action: PayloadAction<string>) {
            state.filters.searchQuery = action.payload;
        },
        mergeEntry(state, action: PayloadAction<Partial<PreparedEntry> & Pick<PreparedEntry, "id">>) {
            if(!action.payload?.id) {
                throw Error("'id' must be provided to mergeEntry reducer");
            }
            state.entries = state.entries?.map((entry) => {
                if(entry.id === action.payload.id) {
                    return {
                        ...entry,
                        ...action.payload,
                    }
                }
                return entry;
            }) ?? null;
        },
    }
});

export const entriesActions = entriesSlice.actions;
export default entriesSlice.reducer;